import MuiButton, { ButtonProps } from '@mui/material/Button';
import React, { forwardRef } from 'react';

/**
 * Extension of Material-UI's `Button`.
 *
 * NOTE: If no variant is provided, "contained" is used as it is the primary button type in Invision. Also, color should typically be specified as "primary".
 */
export const Button = forwardRef<HTMLButtonElement, Omit<ButtonProps, 'css'>>( // Omitted css due to being required with ButtonProps but we should not pass in css
  function ButtonComponent({ variant, color, ...otherProps }, ref) {
    return (
      <MuiButton
        variant={variant || 'contained'}
        color={color || 'secondary'}
        {...otherProps}
        ref={ref}
      />
    );
  }
);
